import config from '../config/configureEnv';
import { ajax, getUserAuthDataFromLocalStorage } from '../utils';

const baseURL = `${config.bocaAPIUrl}/channels`;

export default {
  getChannels: (filters = {}) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', baseURL, {
      data: filters,
      urlParams: { access_token: accessToken },
    });
  },
  createChannel: (displayName = {}) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', baseURL, { data: JSON.stringify(displayName), urlParams: { access_token: accessToken } });
  },
  ackChannelRead: (channelId) => {
    if (!channelId) throw new Error('The channelId of this api is required');
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', `${baseURL}/${channelId}/viewed`, { urlParams: { access_token: accessToken } });
  },
  getInvitableMembers: (channelId) => {
    // if (!channelId) throw new Error('The channelId of this api is required');
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${baseURL}/${channelId}/invitable-members`, { urlParams: { access_token: accessToken } });
  },
  getChannelMembers: (channelId) => {
    if (!channelId) throw new Error('The channelId of this api is required');
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${baseURL}/${channelId}/members`, { urlParams: { access_token: accessToken } });
  },
  addChannelMember: (channelId, userIds) => {
    if (!channelId) throw new Error('The channelId of this api is required');
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    const data = { userId: userIds };
    return ajax('POST', `${baseURL}/${channelId}/members`, { data: JSON.stringify(data), urlParams: { access_token: accessToken } });
  },
  updateChannelTitle: (channelId, title) => {
    if (!channelId) throw new Error('The channelId of this api is required');
    if (!title || title.length === 0) throw new Error('The title of this api couldn\'t be empty or null');
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    const payload = { displayName: title };
    return ajax('PATCH', `${baseURL}/${channelId}`, { data: JSON.stringify(payload), urlParams: { access_token: accessToken } });
  },
  getChannelMessages: (channelId) => {
    if (!channelId) throw new Error('The channelId of this api is required');
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${baseURL}/${channelId}/messages`, { urlParams: { access_token: accessToken } });
  },

  // NOTE: this parameter, fromMsgIdx, is used as closed interval to fetch messages in a range
  getPrevChannelMessages: (channelId, fromMsgIdx, limit = 30) => {
    if (!channelId || !fromMsgIdx) throw new Error('The channelId and fromMsgIdx of this api is required');
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    const filters = { filter: JSON.stringify({ fromMsgIdx, limit }) };
    return ajax('GET', `${baseURL}/${channelId}/messages`, { data: filters, urlParams: { access_token: accessToken } });
  },
  createChannelTextMessage: (channelId, text) => {
    if (!channelId) throw new Error('The channelId of this api is required');
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    const data = { type: 'text', text };
    return ajax('POST', `${baseURL}/${channelId}/messages`, { data: JSON.stringify(data), urlParams: { access_token: accessToken } });
  },
  createChannelImageMessage: (formData, channelId) => {
    if (!channelId) throw new Error('The channelId of this api is required');
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', `${baseURL}/${channelId}/messages/upload`, {
      urlParams: { access_token: accessToken },
      cache: false,
      contentType: false,
      processData: false,
      data: formData,
    });
  },
  getVideoChatSessionInfo: (channelId) => {
    if (!channelId) throw new Error('The channelId of this api is required');
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', `${config.bocaAPIUrl}/chat-rooms/getSession`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify({ channelId }),
    });
  },
  fetchTaggableMedicalRecords: (patientId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/medical-records/patient/${patientId}`, {
      urlParams: { access_token: accessToken },
    });
  },
  uploadChannelAvatar: (channelId, formData) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', `${config.bocaAPIUrl}/channels/${channelId}/avatar`, {
      urlParams: { access_token: accessToken },
      cache: false,
      contentType: false,
      processData: false,
      data: formData,
    });
  },
  deleteChannelMember: (channelId, memberId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('DELETE', `${config.bocaAPIUrl}/channels/${channelId}/members/${memberId}`, {
      urlParams: { access_token: accessToken },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/ChannelAPIConnectors.js